import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import CopyButton from '../components/common/CopyButton';
import PhoneButton from '../components/common/PhoneButton';
import SocialMediaList from '../components/common/SocialMediaList';
import WhatsAppPhoneButton from '../components/common/WhatsAppPhoneButton';
import FooterAddress from './FooterAddress';

interface FooterProps {
}

const Footer: React.FC<FooterProps> = ({ }) => {
    const { t } = useTranslation();
    return (
        <Grid
            p={4}
            mt={{ xs: 4, md: 8 }}
            gap={4}
            container
            bgcolor={"rgb(21, 24, 28)"}
            width={"100%"}
            direction={"column"}
            justifyContent={"start"}
            alignItems={{ xs: "flex-start", md: "center" }}>
            <Box
                display={"grid"}
                justifyContent={"flex-start"}
                width={"auto"}
                gap={{ xs: 6, md: 14 }}
                sx={{
                    gridTemplateColumns: { xs: "repeat(1, 1fr) !important", sm: "repeat(1, 1fr) !important", md: "repeat(2, 1fr) !important", lg: "repeat(3, 1fr) !important" }
                }}>

                <Box display={"flex"} flexDirection={"column"}>
                    <Typography
                        color={(theme) => theme.palette.primary.light}
                        mb={1}
                        fontWeight={600}
                        sx={{
                            // textDecoration: "underline",
                            // textDecorationColor: (theme) => theme.palette.primary.light
                        }}>
                        {t("footer.followUs")}
                    </Typography>
                    <SocialMediaList />
                </Box>

                <Box display={"flex"} flexDirection={"column"}>
                    <Typography
                        color={(theme) => theme.palette.primary.light}
                        mb={1}
                        fontWeight={600}
                        sx={{
                            // textDecoration: "underline",
                            // textDecorationColor: (theme) => theme.palette.primary.light
                        }}>
                        {t("footer.contact")}
                    </Typography>
                    {/* <Box display={"flex"} flexDirection={"row"} flexWrap={"wrap"} alignItems={"flex-start"} gap={{xs: 4, md: 6}}> */}

                    <Box>
                        <Typography color={"#fff"} variant='subtitle2'>+387 63 262 122</Typography>
                        <Typography color={"#fff"} variant='subtitle2'>enduro.radusa@outlook.com</Typography>
                        <Box mt={1} display={"flex"} flexDirection={"row"} gap={2}>
                            <PhoneButton phoneNumber='+387 63 262 122' />
                            <WhatsAppPhoneButton phoneNumber='38763262122' />
                        </Box>
                    </Box>

                    {/* </Box> */}
                </Box>

                <FooterAddress />


            </Box>
        </Grid >
    )
}

export default Footer;